import { NAME } from './constants';
import { apiProvider } from './api';
import { router } from './router';

export const UzaverkaSkladu = {
	name: NAME,
	apiProvider,
	router,
};
